import { EditIcon, LogInIcon, LogOutIcon, UserIcon } from '@zhuowenli/vue-feather-icons';
import ajax from "../../ajax.js";
import NetworkMixin from "../auth/network_mixin";
import { Icon, Modal } from "../../elements";
import Users from "./users.vue";
import Forms from "./forms.vue";
import { eventBus, EVENTS } from "../../event_bus.js";
export default {
  name: "Session",
  mixins: [NetworkMixin],
  data() {
    return {
      user: {
        login: "",
        id: "",
        details: {}
      },
      authTarget: window.envs.authTarget
    };
  },
  components: {
    Forms,
    Icon,
    EditIcon,
    LogInIcon,
    LogOutIcon,
    UserIcon,
    Modal,
    Users
  },
  methods: {
    navigateToEditProfile() {
      window.location.href = `${this.authTarget}/${this.$route.params.locale}/passport?backUrl=${encodeURIComponent(window.location.href)}`;
    },
    reload(force) {
      if (force || window.envs.vueApp != "landing") {
        ajax.get("/api/user").then(response => {
          const content = response.data.content;
          this.user.id = content.id;
          this.user.login = content.login;
          this.user.details = {
            ...content.details
          };
        }).catch(() => {
          this.user.id = "";
          this.user.login = "";
          this.user.details = {};
        });
      }
    },
    logoffCurrentUser() {
      this.networkLogoffUser({
        id: this.user.id,
        currentUser: true
      }).then(r => {
        this.reloadPage();
      });
    },
    showCredentialsModal() {
      this.$refs.credentialsModal.turn();
    },
    reloadPage() {
      this.reload();
      document.location.reload(true);
    }
  },
  created() {
    eventBus.$on(EVENTS.User.Auth.Success, this.reloadPage);
    eventBus.$on(EVENTS.User.Session.Change, this.reload);
  },
  destroyed() {
    eventBus.$off(EVENTS.User.Auth.Success, this.reloadPage);
    eventBus.$off(EVENTS.User.Session.Change, this.reload);
  },
  mounted() {
    this.reload();
  }
};